export enum Endpoint {
  LOCAL_URL = 'http://localhost:4200',
  LOCAL_API_URL = 'http://localhost:5000',
  LOCAL_API_URL_HTTPS = 'https://localhost:44338',
  STAGING_URL = 'https://bclok.starshotsoftware.net:8001',
  PRODUCTION_URL = 'https://starsheetsbackend.azurewebsites.net',
  AZURE_PORTAL_STORAGE = "https://starshotassets.blob.core.windows.net",
  GIPHY_API_KEY = "fQRMhn55WVneZIn5690wh10hngjmWvsF"
}
